import { CommonPointProps } from '@moleculeone/types';

import { ReferenceReactionsButton } from './ReferenceReactionsButton';

export function ReferenceReactionTreeButton(props: CommonPointProps) {
  const { point, scale, padding, reactionData, productId } = props;

  const xModifier = reactionData.substrateSmiles.length > 1 ? 0 : -20;
  const commonPointProps = {
    x: point[0] + xModifier,
    y: point[1],
    width: 50,
    height: 66,
  };

  return (
    <foreignObject
      x={commonPointProps.x - commonPointProps.width * 0.4}
      y={commonPointProps.y - commonPointProps.height / 2}
      width={commonPointProps.width * 0.75}
      height={commonPointProps.height * 0.75}
      style={{
        transform: `scale(${scale * 0.75}, ${scale * 0.75})`,
        transformOrigin: `${commonPointProps.x - commonPointProps.width / 2 / scale}px ${
          commonPointProps.y - commonPointProps.height / scale
        }px`,
        overflow: 'visible',
      }}
    >
      <ReferenceReactionsButton
        reaction={reactionData}
        data-cy={`button-scifinder-reference-reactions-${productId}`}
      />
    </foreignObject>
  );
}
